import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const StyledCompoundUpdatePane = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;

  .content_wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
    width: 100%;
  }

  .buttons-block_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .button_cancel {
    margin-left: 10px;
  }
`;

const CompoundUpdatePane = ({
  onCancel,
  onSave,
  item,
  id,
  children,
  isDisabledSave,
  tenantId,
  location,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!item) {
      navigate(`/${tenantId}/${location}`);
    }
  }, [item, tenantId, location, navigate]);

  return (
    <StyledCompoundUpdatePane>
      {item && (
        <div className="content_wrapper">
          {children}
          <div className="buttons-block_wrapper">
            <div>
              <Button type="primary" disabled={isDisabledSave} onClick={() => onSave(item, id)}>
                Save
              </Button>
            </div>
            <div className="button_cancel">
              <Button onClick={onCancel}>Cancel</Button>
            </div>
          </div>
        </div>
      )}
    </StyledCompoundUpdatePane>
  );
};

export default CompoundUpdatePane;
